module.exports = __webpack_public_path__ + "e0106718/img/dollar-icon.35c9d638.svg";